import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import styles from "./Login.module.css";

export default function ForgotPassword() {
  const navigate  = useNavigate();
  const [email,   setEmail]   = useState("");
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://cms.royalhorizonmobilityltd.com/auth/callback",
    });

    setLoading(false);

    if (error) { setError(error.message); return; }
    setSent(true);
  }

  if (sent) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <div className={styles.brand}>
            <div className={styles.brandIcon}>RH</div>
            <div>
              <div className={styles.brandName}>Royal Horizon</div>
              <div className={styles.brandSub}>Management Portal</div>
            </div>
          </div>
          <h1 className={styles.heading}>Check your email</h1>
          <p className={styles.sub}>
            We sent a password reset link to <strong>{email}</strong>.
            Click the link in the email to set a new password.
          </p>
          <button className={styles.btn} onClick={() => navigate("/login")}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <div className={styles.brandIcon}>RH</div>
          <div>
            <div className={styles.brandName}>Royal Horizon</div>
            <div className={styles.brandSub}>Management Portal</div>
          </div>
        </div>

        <h1 className={styles.heading}>Forgot Password</h1>
        <p className={styles.sub}>
          Enter your email address and we will send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label>Email address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@royalhorizon.com"
              required
              autoFocus
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button type="submit" className={styles.btn} disabled={loading}>
            {loading ? "Sending…" : "Send Reset Link"}
          </button>

          <button
            type="button"
            className={styles.backLink}
            onClick={() => navigate("/login")}
          >
            ← Back to Login
          </button>
        </form>
      </div>
    </div>
  );
}